import { render } from "./EventJournalEntry.vue?vue&type=template&id=35b80540&scoped=true"
import script from "./EventJournalEntry.vue?vue&type=script&lang=js"
export * from "./EventJournalEntry.vue?vue&type=script&lang=js"

import "./EventJournalEntry.vue?vue&type=style&index=0&id=35b80540&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b80540"]])

export default __exports__